export default "__VITE_ASSET__DpCHi98p__"